import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { busHolidayTypeList, tourHolidayTypeList } from 'src/app/modules/booking-flow/holiday/holiday-search-page/helpers/holiday-types';
import getHolidayTypesByAirports from '../../../../helpers/get-holiday-types-by-airports';
import fixArray from '../../../../utils/fixArray';
import { IPrefetchDateParams } from '../../../shared/interfaces/iprefetch-date-params';
import { BookingService } from '../../../shared/services/booking.service';
import { HolidayPrefetchService } from '../../../shared/services/holiday-prefetch.service';
import { MobileService } from '../../../shared/services/mobile.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineTabTypes } from './../../models/engine-tab-types.enum';

@Component({
  selector: 'app-engine-holiday-modal-datepicker',
  templateUrl: './engine-holiday-modal-datepicker.component.html',
  styleUrls: ['./engine-holiday-modal-datepicker.component.scss']
})
export class EngineHolidayModalDatepickerComponent implements OnInit, OnDestroy {

  @Input() selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  @Input() selectedAirport: IEngineParamChange<(number | string)[]>;
  @Input() selectedAccomodation: IEngineParamChange<number>;
  @Input() selectedTour: IEngineParamChange<number>;
  @Input() onlyCustomHoliday: boolean;
  @Input() onlyNetQuotes: boolean;
  @Output() selectedDate = new EventEmitter<IEngineParamChange<NgbDateStruct>>();
  @Input() defaultDate: string;
  @Input() engineTabType: EngineTabTypes;

  prefetchDate: Observable<any>;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  availableDates: NgbDate[];
  selectedDateInternal: NgbDateStruct;
  loadingStatus: boolean;
  loadingMessage: string;
  prefetchDateSubscription: Subscription;
  isMobile$: Observable<boolean>;
  modal = this._activeModal;

  constructor(private _activeModal: NgbActiveModal,
              private _holidayPrefetchService: HolidayPrefetchService,
              private _mobileService: MobileService,
              private _bookingService: BookingService) { }

  ngOnInit(): void {
    if (this.selectedDestination?.resetParams || this.selectedAirport?.resetParams || this.selectedTour?.resetParams) {
      this.selectDate(undefined);
    }
    if ((this.selectedDestination?.value || this.selectedDestination?.id || this.selectedAccomodation?.value || this.selectedTour?.value) && 
      (this.engineTabType === EngineTabTypes.Bus || this.selectedAirport?.value)) {
      const selectedAirport = this.selectedAirport?.value;
      // in base alla tab engine selezionata, imposto dei typeList dedicati
      let holidayTypeList: number[];
      switch (this.engineTabType) {
        case EngineTabTypes.Bus:
          // se selezionata la tab engine dei Bus, imposto i typeList dedicati solo ai prodotti con Bus
          holidayTypeList = busHolidayTypeList;
          break;
        case EngineTabTypes.Tour:
          // se selezionata la tab engine dei Tour, imposto i typeList dedicati solo ai prodotti con Tour
          holidayTypeList = tourHolidayTypeList;
          break;
        default:
          // di default, vengono recuperati dei typeList in base all'id della partenza selezionata (aeroporto, bus, nave, ecc..)
          holidayTypeList = getHolidayTypesByAirports(fixArray(selectedAirport));
      }
      const params: IPrefetchDateParams = {
        destination: this.selectedDestination?.value?.id ? fixArray(this.selectedDestination.value.id) : undefined,
        accommodations: this.selectedAccomodation?.value ? fixArray(this.selectedAccomodation.value) : undefined,
        tours: this.selectedTour?.value ? fixArray(this.selectedTour.value) : undefined,
        departurePlace: selectedAirport ? fixArray(selectedAirport) : undefined,
        onlyCustomHoliday: this.onlyCustomHoliday,
        onlyNetQuotes: this.onlyNetQuotes,
        ages: this._bookingService.getAgesArray(),
        holidayTypeList
      };
      this.prefetchDate = this._holidayPrefetchService.prefetchDate(params);
      this.prefetchDateSubscription = this.prefetchDate.subscribe(e => {
        if (e && e.length > 0) {
          this.availableDates = e.map(d => d.split('-').map(i => parseInt(i, 10))).map(d => new NgbDate(d[0], d[1], d[2]));
          this.minDate = this.availableDates[0];
          this.maxDate = this.availableDates[this.availableDates.length - 1];
        }
      });
      this.isMobile$ = this._mobileService.isMobile();
    }
    if (this.defaultDate) {
      const tmpDate = this.defaultDate.split('-').map(i => parseInt(i, 10));
      this.selectDate(new NgbDate(tmpDate[0], tmpDate[1], tmpDate[2]), false);
    }
  }

  selectDate(date: NgbDate, resetParams: boolean = true): void {
    this.selectedDateInternal = date;
    this.selectedDate.emit({value: date, resetParams});
    
  }

  onDateSelected(date: NgbDate): void {
    this.selectDate(date);
    this._activeModal.dismiss();
  }

  isDisabledDate = (date: NgbDate) => {
    return this.availableDates ? !this.availableDates.some(e => e.equals(date)) : true;
  }

  ngOnDestroy(): void {
    this.prefetchDateSubscription?.unsubscribe();
  }

}
